import { Component, AfterViewInit, Input } from "@angular/core";
import { ApplicationPool } from "src/app/services/application.pool";
import { trigger, transition, style, animate } from "@angular/animations";
import { ActionService } from "../services/action.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { GeneralGuard } from "../guards/general.guard";

@Component({
  selector: "loading-animation",
  templateUrl: "./loading-animation.component.html",
  styleUrls: ["./loading-animation.component.scss"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("1s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("1s ease-in", style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class LoadingAnimationComponent implements AfterViewInit {
  @Input() public visible: boolean | undefined = undefined;

  get IsLogin() {
    return document.location.pathname.startsWith("/login");
  }

  get DisplayBar(): boolean {
    return this.lastWidth >= 0 && !this.IsDisconnected;
  }

  private lastWidth = 0;
  private hadWidth = false;
  get Width(): string {
    if (this.dataPool.getTotal > 0 && this.dataPool.isLoading) {
      const width = Math.abs(
        ((this.dataPool.getTotal - this.dataPool.getCurrent) /
          this.dataPool.getTotal) *
          100
      );
      if (width == 0) this.lastWidth = -1;
      else this.lastWidth = width;
      if (this.lastWidth > 0) this.hadWidth = true;
    }
    if (this.overrideDisabled && this.hadWidth) return "100%";
    return this.lastWidth.toString() + "%";
  }

  private lastLoadingValue = true;
  private timeout = null;
  public override = environment.displayLoadingAnimationOnLaunch;
  public overrideDisabled = environment.displayLoadingAnimationOnLaunch;
  public get IsLoading(): boolean {
    if (this.override) return true;
    if (GeneralGuard.isLoading) return true;
    const loading = this.dataPool.isLoading;
    if (loading != this.lastLoadingValue && !this.timeout) {
      this.lastLoadingValue = this.dataPool.isLoading;
    }

    if (!this.lastLoadingValue) {
      this.lastWidth = 0;
    }

    return this.lastLoadingValue;
  }

  public get IsDisconnected(): boolean {
    return !this.dataPool.WssConnected;
  }

  constructor(
    private dataPool: ApplicationPool,
    private dataService: ActionService,
    private router: Router
  ) {
    setTimeout(() => {
      this.override = false;
    }, 1000);
    setTimeout(() => {
      this.overrideDisabled = false;
    }, 2000);
  }

  ngAfterViewInit(): void {}

  public restart() {
    localStorage.removeItem("token");
    document.location.href = "/";
  }

  public logout() {
    this.dataService.logout();
    this.router.navigate(["/login"], { replaceUrl: true });
  }
}
